import 'isomorphic-unfetch'; // Polyfill fetch

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { noop } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import MegaMenu from './components/mega-menu';
import MobileNavigation from './mobile-navigation';
import NoScroll from '../../components/no-scroll';
import OutsideClickTracker from '../../components/outside-click-tracker';
import Viewport from '../../components/viewport';
import Overlay from '../../components/overlay';

import menuActions from './actions/desktop';
import mobileMenuActions from './actions/mobile-menu';

import * as S from './styles';

class NavigationMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fullTree: false,
    };
  }

  componentDidMount() {
    const { market } = this.context;

    fetch(`/_internal/menu-tree`, {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        const categories = data.items;
        const sortedCategories = categories
          .slice()
          // Sort mega menu categories by name on the top level
          .sort((a, b) =>
            a.name.localeCompare(b.name, market.locale.replace('_', '-'))
          );

        this.props.setInitialMobileMenuData(categories);
        this.setState({
          fullTree: true,
          sortedCategories,
        });

        // Open the first category in mega menu by default
        this.changeMegaMenuCategory(sortedCategories[0].id);
      })
      .catch(err => {
        if (
          !err ||
          err.message !== 'isomorphic-unfetch not implemented in tests'
        ) {
          console.error(err);
        }
      });
  }

  toggleMegaMenuByCategory = openCategory => {
    if (openCategory) {
      this.changeMegaMenuCategory(openCategory);
    }
    this.props.toggleMenu({ open: !!openCategory });
  };

  changeMegaMenuCategory = openCategory => {
    this.props.changeCategory({ openCategory });
  };

  closeMegaMenu = () => {
    // Trigger redux action to change the state
    this.props.toggleMenu({ open: false });
    // Callback for side effects in parent component
    this.props.onCloseMegaMenu();
  };

  openCategoryLink = categoryId => {
    this.props.openCategoryLink({ categoryId });
  };

  render() {
    const { openCategory, open } = this.props;
    const { sortedCategories, fullTree } = this.state;

    return (
      <>
        <Viewport mobile tablet>
          <MobileNavigation />
        </Viewport>

        <Viewport desktop>
          <S.NudgedBox visible={open}>
            <OutsideClickTracker
              onClickOutside={this.closeMegaMenu}
              onEscapeKey={this.closeMegaMenu}
            >
              <S.NavigationWrapper>
                {sortedCategories && (
                  <MegaMenu
                    openCategoryId={fullTree ? openCategory : null}
                    categories={sortedCategories}
                    onOpenCategory={this.changeMegaMenuCategory}
                    onClose={this.closeMegaMenu}
                    onOpenCategoryLink={this.openCategoryLink}
                  />
                )}
              </S.NavigationWrapper>
            </OutsideClickTracker>
          </S.NudgedBox>
          <Overlay active={open} />
          <NoScroll enabled={open} />
        </Viewport>
      </>
    );
  }
}

const { bool, func, shape, string, arrayOf, node } = PropTypes;

NavigationMenu.propTypes = {
  openCategory: string,
  open: bool,
  toggleMenu: func,
  setInitialMobileMenuData: func,
  rootCategories: arrayOf(
    shape({
      id: string,
      name: string,
      semantic_id: string,
    })
  ),
  outsiderTrackContent: node,
  changeCategory: func,
  openCategoryLink: func,
  onCloseMegaMenu: func,
};

NavigationMenu.defaultProps = {
  openCategory: null,
  open: false,
  rootCategories: undefined,
  outsiderTrackContent: undefined,
  changeCategory: noop,
  openCategoryLink: noop,
  onCloseMegaMenu: noop,
  toggleMenu: noop,
  setInitialMobileMenuData: noop,
};

NavigationMenu.contextType = AppContext;

export default connect(state => state.areas.navigation.megaMenu, {
  ...menuActions,
  setInitialMobileMenuData: mobileMenuActions.setInitialData,
})(NavigationMenu);
